import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createLoggedPlayersPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            key: 'data-table-expand',
            value: 'data-table-expand',
            align: 'center',
            sortable: false,
            minWidth: 28,
            width: 28,
            cellProps: { class: 'px-0' },
        },
        {
            title: '',
            value: 'select',
            key: 'select',
            align: 'center',
            sortable: false,
            minWidth: 26,
            width: 26,
            cellProps: { class: 'px-0' },
            headerProps: { class: 'px-0' },
        },
        {
            title: t('loggedPlayers.connectionId'),
            value: 'connectionId',
            key: 'connectionId',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.appId'),
            value: 'uniqAppId',
            key: 'uniqAppId',
            align: 'start',
            sortable: true,
            cellProps: { class: 'nowrap' },
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.scriptVersion'),
            value: 'scriptVersion',
            key: 'scriptVersion',
            align: 'start',
            sortable: true,
            cellProps: { class: 'nowrap' },
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.userName'),
            value: 'userLogin',
            key: 'userLogin',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.ip'),
            value: 'ip',
            key: 'ip',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.os'),
            value: 'os',
            key: 'os',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.browser'),
            value: 'browser',
            key: 'browser',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.pageUrl'),
            value: 'pageUrl',
            key: 'pageUrl',
            align: 'start',
            sortable: true,
            nowrap: true,
            headerProps: { class: 'nowrap' },
            cellProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.pageCode'),
            value: 'pageCode',
            key: 'pageCode',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.sessionStartedAt'),
            value: 'startAt',
            key: 'startAt',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.updatedAt'),
            value: 'updateUserDate',
            key: 'updateUserDate',
            align: 'start',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.betPopups'),
            value: 'betPopupsCount',
            key: 'betPopupsCount',
            align: 'center',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('loggedPlayers.favEvents'),
            value: 'favEventsCount',
            key: 'favEventsCount',
            align: 'center',
            sortable: true,
            headerProps: { class: 'nowrap' },
        },
        {
            title: '',
            value: 'infoMenu',
            key: 'infoMenu',
            align: 'center',
            sortable: false,
            minWidth: 20,
            width: 20,
            cellProps: { class: 'px-1' },
        },
    ];
}
